import type { OpenChatSideBar, CloseChatSideBar } from 'state/actions/chat-details';
import { OPEN_CHAT_SIDE_BAR, CLOSE_CHAT_SIDE_BAR } from 'state/actions/chat-details';

export interface chatDetailsUIState {
    isChatSideBarOpen: boolean;
}

export const chatDetailsDefaultState: chatDetailsUIState = {
    isChatSideBarOpen: false,
};

export function chatDetailsReducer(
    state: chatDetailsUIState = chatDetailsDefaultState,
    action: OpenChatSideBar | CloseChatSideBar
): chatDetailsUIState {
    if (action.type === OPEN_CHAT_SIDE_BAR) {
        return {
            ...state,
            isChatSideBarOpen: true,
        };
    }
    if (action.type === CLOSE_CHAT_SIDE_BAR) {
        return {
            ...state,
            isChatSideBarOpen: false,
        };
    }
    return state;
}
